import { AiFillHtml5, AiFillGithub } from "react-icons/ai";
import {
  SiCss3,
  SiRedux,
  SiTailwindcss,
  SiBootstrap,
  SiCanva,
  SiMui,
  SiExpress,
  SiNestjs,
  SiMongodb,
  SiRedis,
} from "react-icons/si";
import { BiLogoJavascript, BiLogoTypescript } from "react-icons/bi";
import { FaReact, FaNodeJs } from "react-icons/fa";
import { TbBrandMysql, TbBrandNextjs } from "react-icons/tb";
import { BsGit } from "react-icons/bs";
import {
  Mail,
  Linkedin,
  Github,
  Twitter,
  Rocket,
  Sparkles,
  Zap,
  Terminal,
} from "lucide-react";

export const techIcons = {
  html: AiFillHtml5,
  css: SiCss3,
  javascript: BiLogoJavascript,
  react: FaReact,
  nextjs: TbBrandNextjs,
  typescript: BiLogoTypescript,
  redux: SiRedux,
  mui: SiMui,
  tailwind: SiTailwindcss,
  bootstrap: SiBootstrap,
  nodejs: FaNodeJs,
  express: SiExpress,
  nestjs: SiNestjs,
  mysql: TbBrandMysql,
  mongodb: SiMongodb,
  redis: SiRedis,
  git: BsGit,
  github: AiFillGithub,
  canva: SiCanva,
};

export const socialIcons = {
  email: Mail,
  linkedin: Linkedin,
  github: Github,
  twitter: Twitter,
};

export const homeIcons = {
  rocket: Rocket,
  sparkles: Sparkles,
  zap: Zap,
  terminal: Terminal,
};
